import { takeLatest, put, call } from 'redux-saga/effects';
import * as types from './actionTypes';
import { fetchChatsSuccess, addMessageSuccess } from './actions';

// Helper functions for localStorage
const getChatsFromStorage = () => {
  const chats = localStorage.getItem('chats');
  return chats ? JSON.parse(chats) : [];
};

const saveChatsToStorage = (chats) => {
  localStorage.setItem('chats', JSON.stringify(chats));
};

function* fetchChatsSaga() {
  try {
    const chats = yield call(getChatsFromStorage);
    yield put(fetchChatsSuccess(chats));
  } catch (error) {
    console.error('Error fetching chats:', error);
  }
}

function* addMessageSaga(action) {
  try {
    const { channelName, message_id,message, from } = action.payload;
    const chats = yield call(getChatsFromStorage);
    
    const chatIndex = chats.findIndex(chat => chat.channel_name === channelName);
    if (chatIndex !== -1) {
      chats[chatIndex].chats.push({
        message_id,
        message,
        from
      });
    } else {
      chats.push({
        channel_name: channelName,
        chats: [{
          message_id,
          message,
          from
        }]
      });
    }
    
    yield call(saveChatsToStorage, chats);
    yield put(addMessageSuccess(chats.find(chat => chat.channel_name === channelName)));
  } catch (error) {
    console.error('Error adding message:', error);
  }
}

export function* chatSaga() {
  yield takeLatest(types.FETCH_CHATS, fetchChatsSaga);
  yield takeLatest(types.ADD_MESSAGE, addMessageSaga);
}